import React from "react";
import "./EndMessage.css";

export default function EndMessage({ won }: { won: boolean }) {
  return (
    <div className="end-message">
      <h3>{won ? "Congratulations" : "Game Over"}</h3>
      <h5>Press [Space] to try again</h5>
    </div>
  );
}
